/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Actions_LabelInputs */

const en_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correction actions`)
};

const fr_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions de correction`)
};

const de_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrekturmaßnahmen`)
};

const it_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni correttive`)
};

const ru_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меры по исправлению ситуации`)
};

const es_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones correctivas`)
};

const zh_cn2_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纠正措施`)
};

const ja_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是正措置`)
};

const hi_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुधारात्मक कार्रवाइयां`)
};

const pt_pt2_spellcheck_actions_label = /** @type {(inputs: Spellcheck_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações corretivas`)
};

/**
* | output |
* | --- |
* | "Correction actions" |
*
* @param {Spellcheck_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_actions_label = /** @type {((inputs?: Spellcheck_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_actions_label(inputs)
	if (locale === "de") return de_spellcheck_actions_label(inputs)
	if (locale === "it") return it_spellcheck_actions_label(inputs)
	if (locale === "ru") return ru_spellcheck_actions_label(inputs)
	if (locale === "es") return es_spellcheck_actions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_actions_label(inputs)
	if (locale === "ja") return ja_spellcheck_actions_label(inputs)
	if (locale === "hi") return hi_spellcheck_actions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_actions_label(inputs)
	return en_spellcheck_actions_label(inputs)
});